import classNames from 'classnames';
import { getActivityStatus } from 'utils';
import { isCHFReading } from 'utils/get-reading-info';
import { LATENT_READING_DIFF_HOURS } from 'infrastructure/consts';
import { getDiffInHours } from 'infrastructure/functions';

import s from './styles.module.scss';
import CHFRenalStatus from './chf-renal-status';
import RecoveredStatus from './recovered-status';
import LatentReadingStatus from './latent-reading-status';

import type {
  TMightBeErroneousReason,
  TThresholdName,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { IPatientThresholds } from 'infrastructure/interfaces';
import type { FC } from 'react';
import type { ReadingStatus } from 'infrastructure/enums';

interface StatusCellProps {
  globalStatus: ReadingStatus;
  thresholdName?: TThresholdName | null;
  thresholds: IPatientThresholds;
  mightBeErroneousReason?: TMightBeErroneousReason;
  isRecovered?: boolean;
  wrapperClassName?: string;
  receivedTime?: string;
  readingTime?: string;
  timezone: string;
}

const StatusCell: FC<StatusCellProps> = ({
  globalStatus,
  thresholdName,
  thresholds,
  mightBeErroneousReason,
  isRecovered,
  wrapperClassName,
  receivedTime,
  readingTime,
  timezone,
}) => {
  const status = getActivityStatus(globalStatus);
  const isCHF = isCHFReading(thresholdName);

  const diffTime = getDiffInHours({
    biggerDate: receivedTime,
    date: readingTime,
  });

  const showLatentStatus = diffTime
    ? diffTime >= LATENT_READING_DIFF_HOURS
    : false;

  return (
    <div className={wrapperClassName}>
      {showLatentStatus && receivedTime && (
        <LatentReadingStatus receivedTime={receivedTime} timezone={timezone} />
      )}
      <p
        data-cy="reading-status"
        className={classNames(s.status, s[`status-${globalStatus}`])}
      >
        {status}
      </p>
      {isRecovered && <RecoveredStatus />}
      {!isRecovered && thresholdName && isCHF && (
        <CHFRenalStatus
          thresholdName={thresholdName}
          thresholds={thresholds}
          mightBeErroneousReason={mightBeErroneousReason}
        />
      )}
    </div>
  );
};
export default StatusCell;
